import React from 'react';
import tpl from '../templates/greenPolicy';
import BaseNewCardView from '../../Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props, context) {
        super(props, context);

        const ssrData = context && context.ssrData;

        this.state = {
            ...this.state,
            tab: 'insurer-info',
            detailedInfoWidget: (ssrData && ssrData.detailedInfoWidget) || [],
            detailedInfoWidget_loading: !(ssrData && ssrData.detailedInfoWidget)
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.widgetsHelper.getWidgetsByPath.call(this, {
            path: '/services/green-policy_infoinsurance',
            widgetKey: 'detailedInfoWidget'
        });
    }

    static displayName = 'Services.Policy';
}
